import React from 'react';
import NewProjectService from '../../../Services/NewProjectService';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
//import selectHelper from '../../../Helpers/selectHelper';
import NewProjectItem from '../../../Domain/ThirdParty/Project/NewProjectItem';

class EditNewProjectWindowDescription extends React.Component {
  static titleForCreate = 'Add New Project';
  static titleForEdit = 'Edit Project';
  static ComponentName = 'Project';
  static itemType = NewProjectItem;
  static serviceFunction = (edited) =>
    edited.IsNewProject ? NewProjectService.CreateNewProject(edited) : NewProjectService.SaveEditedProject(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ProjectName',
          label: 'Project *',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
        },
        {
          fieldName: 'ContactId',
          label: 'Contact *',
          className: 'col-6',
          type: InputTypesEnum.ContactSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          idFilter: 'BravoClientId',
        },
        {
          fieldName: 'ProjectManagerUserId',
          label: 'Project Manager *',
          className: 'col-12',
          type: InputTypesEnum.ProjectManagerSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'StartDate',
          label: 'Start Date *',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
        {
          fieldName: 'EndDate',
          label: 'End Date *',
          className: 'col-6',
          type: InputTypesEnum.Date,
          validityChecker: EditNewProjectWindowDescription.validityCheckerForStartAndEndDate,
        },
        {
          fieldName: 'OpportunityId',
          label: 'Opportunity *',
          className: 'col-6',
          type: InputTypesEnum.ProjectOpportunitySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          // idFilterArray: ['BravoClientId', 'StartDate', 'EndDate'],
          idFilterArray: [
            { filterName: 'ClientId', valueName: 'BravoClientId' },
            { filterName: 'CfStartDate', valueName: 'StartDate' },
            { filterName: 'CfEndDate', valueName: 'EndDate' },
          ],
          hide: (item) => item.IsEditedProject === true,
        },
        {
          fieldName: 'ServiceId',
          label: 'Service *',
          className: 'col-6',
          type: InputTypesEnum.ProjectServiceSelect,
          idFilter: 'OpportunityId',
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => item.IsEditedProject === true,
        },
        {
          fieldName: 'ShopCountInCycle',
          label: 'Shop Count In Cycle',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.IsEditedProject === true,
        },
        // {
        //   fieldName: 'ReimbursementType',
        //   label: 'Reimbursement Type',
        //   className: 'col-6',
        //   type: InputTypesEnum.Select,
        //   validityChecker: ValidityHelper.AlwaysFlawless,
        //   selectvalues: EditNewProjectWindowDescription.getReimbursementTypeSelectOptions(),
        // },
        {
          fieldName: 'IgnoreExpensesForClientInvoice',
          label: 'Ignore Expenses For Client Invoice?',
          className: 'col-6',
          type: InputTypesEnum.Bool,
          validityChecker: ValidityHelper.forRequiredBoolField,
          hide: (item) => item.IsEditedProject === true,
        },
        {
          fieldName: 'Comments',
          label: 'Summary',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          numberOfRows: 2,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];

  // static getReimbursementTypeSelectOptions() {
  //   return selectHelper.generateSelectValues([
  //     '',
  //     'Use Shopper Reimbursement Field',
  //     'Use Client Reimbursement Field',
  //   ]);
  // }

  static validityCheckerForStartAndEndDate(e, editedItem) {
    if (editedItem) {
      return new Date(editedItem.StartDate) > new Date(editedItem.EndDate)
        ? 'End Date must be later than Start Date.'
        : '';
    }
    return '';
  }
}

export default EditNewProjectWindowDescription;
